<template>
  <div class="p-4 bg-white rounded-lg shadow animate-pulse">
    <!-- Image Placeholder -->
    <div class="w-full h-32 bg-gray-300 rounded mb-3"></div>
    <!-- Title Placeholder -->
    <div class="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
    <!-- Text Placeholder -->
    <div class="h-3 bg-gray-200 rounded w-1/2 mb-2"></div>
    <div class="h-3 bg-gray-200 rounded w-5/6"></div>
  </div>
</template>

<script setup lang="ts">
// Pas de logique nécessaire
</script>
